import {
    ARTIST_DATA_CHANGED,
    ARTIST_DATA_RESET,
    CLEAR_ARTIST_DATA,
    LOAD_ARTIST_BASE_DATA,
    LOAD_ARTIST_BASE_DATA_SUCCESS
} from "./artistActions";
import {
    asyncLoadingActionSuccess,
    initiateAsyncLoadingWithParamsAction
} from "../utils/reducerUtils";

const INITIAL = {}

export default function artistEditReducers(state = INITIAL, action) {
    switch (action.type) {
        case LOAD_ARTIST_BASE_DATA:
            return initiateAsyncLoadingWithParamsAction(state, 'artistBaseData', {artistId: action.payload.artistId})

        case LOAD_ARTIST_BASE_DATA_SUCCESS:
            return asyncLoadingActionSuccess(state, action, 'artistBaseData')

        case CLEAR_ARTIST_DATA:
            return INITIAL

        case ARTIST_DATA_CHANGED:
            return {
                ...state
                , artistDataChanged: true
            }
        case ARTIST_DATA_RESET:
            return {
                ...state
                , artistDataChanged: undefined
            }

        default:
            return state
    }
}